import Card from './components/card'
import Logo from './components/logo'
import AppLinkLogo from './components/app-link-logo'
import HeaderFields from './components/header-fields'
import Fields from './components/fields'
import Barcode from './components/barcode'
import BoardingPassPrimary from './components/boarding-pass-primary'

const BoardingPass = ({ passFieldCount }) => {

  return (
    <div className="relative">
      <Card>
        <Logo />
        <HeaderFields maxFields={passFieldCount.header} />
        <BoardingPassPrimary />
        {/* Secondary and Auxillary fields reversed - as are the sizes. Position is set in passes.less But we have reverse the fieldType parameter here to be obvious */}
        <Fields maxFields={passFieldCount.secondary} fieldType="secondary" />
        <Fields maxFields={passFieldCount.auxiliary} fieldType="auxiliary" />
        <AppLinkLogo />
        <Barcode />
      </Card>
      <Clipmap />
    </div>
  )
}

export default BoardingPass

const Clipmap = () => (
  <svg className='apple-svg-clip absolute top-0'>
    <defs>
      <clipPath id="apple_clip_path">
        <path id="clip" d="M 375 130.612 C 371.61 130.708 368.891 133.487 368.891 136.9 C 368.891 140.313 371.61 143.092 375 143.188 L 375 513 C 375 518.523 370.523 523 365 523 L 10 523 C 4.477 523 0 518.523 0 513 L 0 142.822 C 0.024 142.822 0.049 142.822 0.073 142.822 C 3.547 142.822 6.364 140.005 6.364 136.531 C 6.364 133.057 3.547 130.24 0.073 130.24 C 0.049 130.24 0.024 130.24 0 130.24 L 0 10 C 0 4.477 4.477 0 10 0 L 365 0 C 370.523 0 375 4.477 375 10 Z M 0 487 C 0 487 0 487 0 487 Z"/>
      </clipPath>
    </defs>
    <use href="#clip"/>
  </svg>
)


